<div *ngFor="let item of details" class="mb-4">
  <h2>{{item.label | translate}}</h2>
  <ng-container *ngIf="item.value; else __noData">{{item.value}}</ng-container>
  <ng-template #__noData>
    <div>
      {{'indicators.generic.noData' | translate}}
    </div>
  </ng-template>
</div>
